import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Ansprechpartner = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path d="M6.75 22h18.5c0.414 0 0.75 0.336 0.75 0.75s-0.336 0.75-0.75 0.75h-18.5c-0.414 0-0.75-0.336-0.75-0.75s0.336-0.75 0.75-0.75zM6.75 25.5h18.5c0.414 0 0.75 0.336 0.75 0.75s-0.336 0.75-0.75 0.75h-18.5c-0.414 0-0.75-0.336-0.75-0.75s0.336-0.75 0.75-0.75zM7 5h18c0.552 0 1 0.448 1 1v13c0 0.552-0.448 1-1 1h-18c-0.552 0-1-0.448-1-1v-13c0-0.552 0.448-1 1-1zM16 14.073c-1.304 0-2.492 0.295-3.405 0.85s-1.595 1.443-1.595 2.524v-0.122 1.158h10v-1.036c0-1.081-0.682-1.968-1.595-2.524s-2.102-0.85-3.405-0.85zM16 13.521c1.534 0 2.778-1.236 2.778-2.76s-1.244-2.76-2.778-2.76c-1.534 0-2.778 1.236-2.778 2.76s1.243 2.76 2.778 2.76z" />
  </SvgIcon>
);

export default Ansprechpartner;
